import { ROUTE_MAP } from './url';

export const APARTMENT_ADAPTER = {
  studio: {
    label: 'Căn hộ 1PN',
    abbreviation: '1PN',
    bed: 1,
    wc: 1,
    scene: '68fafb7ae62230d4b4453d49',
    mini: '/assets/images/floorImg/studio.webp',
    url: 'studio',
  },
  '1pn': {
    label: 'Căn hộ 1PN',
    abbreviation: '1PN',
    bed: 1,
    wc: 1,
    scene: '68fadb0abeb5aead0ada1c6b',
    mini: '/assets/images/floorImg/1pn.webp',
    url: '1bedroom',
  },
  '1pn-plus': {
    label: 'Căn hộ 1PN+',
    abbreviation: '1PN+',
    bed: 1,
    wc: 1,
    scene: '68fadb0abeb5aead0ada1c6b',
    mini: '/assets/images/floorImg/1pn-plus.webp',
    url: '1bedroom-plus',
  },
  '2pn-1wc': {
    label: 'Căn hộ 2PN-1WC',
    abbreviation: '2PN-1WC',
    bed: 2,
    wc: 1,
    scene: '68fafb04e62230d4b4453c85',
    mini: '/assets/images/floorImg/2pn-1wc.webp',
    url: '2bedroom-1wc',
  },
  '2pn-2wc': {
    label: 'Căn hộ 2PN-2WC',
    abbreviation: '2PN-2WC',
    bed: 2,
    wc: 2,
    scene: '68fafb04e62230d4b4453c85',
    mini: '/assets/images/floorImg/2pn-2wc.webp',
    url: '2bedroom-2wc',
  },
  '3pn': {
    label: 'Căn hộ 3PN',
    abbreviation: '3PN',
    bed: 3,
    wc: 2,
    scene: '68faffe9e62230d4b44540ff',
    mini: '/assets/images/floorImg/3pn.webp',
    url: '3bedroom',
  },
  '3pn-dualkey': {
    label: 'Căn hộ 3PN-Dualkey',
    abbreviation: '3PN-Dual Key',
    bed: 3,
    wc: 2,
    scene: '68faffe9e62230d4b44540ff',
    mini: '/assets/images/floorImg/3pn-dualkey.webp',
    url: '3bedroom-dualkey',
  },
};

export const AMENITY_ADAPTER = {
  shophouse: {
    label: 'Shophouse',
    scene: '68fb00b9e62230d4b445417f',
    url: 'shophouse',
  },
  pool: { label: 'Hồ bơi', scene: '68fb00d0e62230d4b44541ac', url: 'pool' },
  playground: {
    label: 'Sân thể thao',
    scene: '68fb00c3e62230d4b4454193',
    url: 'playground',
  },
};

export const AMENITIES_MAP = {
  '6903592c085ec50c650870ca': {
    label: 'Win-Mec',
    short: 'Win-Mec',
    url: `/${ROUTE_MAP.amenities.id}/win-mec`,
  },
  '68fb02e7e62230d4b445441b': {
    label: 'Win-Mark',
    short: 'Win-Mark',
    url: `/${ROUTE_MAP.amenities.id}/win-mark`,
  },
  '68fb00d0e62230d4b44541ac': {
    label: 'Hồ bơi',
    short: 'Hồ bơi',
    url: `/${ROUTE_MAP.amenities.id}/ho-boi`,
  },
  '68fb00b9e62230d4b445417f': {
    label: 'Shophouse',
    short: 'Shophouse',
    url: `/${ROUTE_MAP.amenities.id}/shophouse`,
  },
  '68fb02f3e62230d4b445443c': {
    label: 'Win-Edu',
    short: 'Win-Edu',
    url: `/${ROUTE_MAP.amenities.id}/win-edu`,
  },
  '68fb0303e62230d4b4454459': {
    label: 'Nhà trẻ',
    short: 'Nhà trẻ',
    url: `/${ROUTE_MAP.amenities.id}/nha-tre`,
  },
  '68fb00c3e62230d4b4454193': {
    label: 'Sân thể thao',
    short: 'Sân thể thao',
    url: `/${ROUTE_MAP.amenities.id}/san-the-thao`,
  },
  '691d8f809d4e2e854cdb4192': {
    label: 'Sảnh đón',
    short: 'Sảnh đón',
    url: `/${ROUTE_MAP.amenities.id}/sanh-don`,
  },
};

export const APARTMENT_MAP = {
  // Studio
  '68fafb7ae62230d4b4453d49': {
    label: 'Căn hộ 1pn',
    short: '1pn',
    url: `/${ROUTE_MAP.interior.id}/1pn/tong-quan`,
  },
  '68fa5dce3294b0149d46bb1f': {
    label: 'Căn hộ 1pn - Phòng khách',
    short: '1pn - Phòng khách',
    url: `/${ROUTE_MAP.interior.id}/1pn/phong-khach`,
  },
  '68fa5dd33294b0149d46bb2a': {
    label: 'Căn hộ 1pn - Phòng ngủ',
    short: '1pn - Phòng ngủ',
    url: `/${ROUTE_MAP.interior.id}/1pn/phong-ngu`,
  },
  '68fafb6de62230d4b4453d30': {
    label: 'Căn hộ 1pn - Nhà vệ sinh',
    short: '1pn - Nhà vệ sinh',
    url: `/${ROUTE_MAP.interior.id}/1pn/nha-ve-sinh`,
  },

  // 1PN Plus
  '68fadb0abeb5aead0ada1c6b': {
    label: 'Căn hộ 1PN Plus',
    short: '1PN+',
    url: `/${ROUTE_MAP.interior.id}/1pn-plus/tong-quan`,
  },
  '68fadb07beb5aead0ada1c60': {
    label: 'Căn hộ 1PN+ - Nhà vệ sinh',
    short: '1PN+ - Nhà vệ sinh',
    url: `/${ROUTE_MAP.interior.id}/1pn-plus/nha-ve-sinh`,
  },
  '68fadb13beb5aead0ada1c97': {
    label: 'Căn hộ 1PN+ - Phòng ngủ phụ',
    short: '1PN+ - Phòng ngủ phụ',
    url: `/${ROUTE_MAP.interior.id}/1pn-plus/phong-ngu-phu`,
  },
  '68fadb11beb5aead0ada1c8c': {
    label: 'Căn hộ 1PN+ - Phòng ngủ master',
    short: '1PN+ - Phòng ngủ master',
    url: `/${ROUTE_MAP.interior.id}/1pn-plus/phong-ngu-master`,
  },
  '68fadb0ebeb5aead0ada1c81': {
    label: 'Căn hộ 1PN+ - Phòng khách',
    short: '1PN+ - Phòng khách',
    url: `/${ROUTE_MAP.interior.id}/1pn-plus/phong-khach`,
  },
  '68fadb0cbeb5aead0ada1c76': {
    label: 'Căn hộ 1PN+ - Ban công',
    short: '1PN+ - Ban công',
    url: `/${ROUTE_MAP.interior.id}/1pn-plus/ban-cong`,
  },

  // 2PN
  '68fafb04e62230d4b4453c85': {
    label: 'Căn hộ 2PN',
    short: '2PN',
    url: `/${ROUTE_MAP.interior.id}/2pn/tong-quan`,
  },
  '68fadb1bbeb5aead0ada1cb8': {
    label: 'Căn hộ 2PN - Phòng khách',
    short: '2PN - Phòng khách',
    url: `/${ROUTE_MAP.interior.id}/2pn/phong-khach`,
  },
  '68fafac4e62230d4b4453bc0': {
    label: 'Căn hộ 2PN - Ban công',
    short: '2PN - Ban công',
    url: `/${ROUTE_MAP.interior.id}/2pn/ban-cong`,
  },
  '68fafa0ee62230d4b4453afb': {
    label: 'Căn hộ 2PN - Phòng ngủ 1',
    short: '2PN - Phòng ngủ 1',
    url: `/${ROUTE_MAP.interior.id}/2pn/phong-ngu-1`,
  },
  '68fafaade62230d4b4453b94': {
    label: 'Căn hộ 2PN - Phòng ngủ 2',
    short: '2PN - Phòng ngủ 2',
    url: `/${ROUTE_MAP.interior.id}/2pn/phong-ngu-2`,
  },
  '68fafa3fe62230d4b4453b4b': {
    label: 'Căn hộ 2PN - Hành lang',
    short: '2PN - Hành lang',
    url: `/${ROUTE_MAP.interior.id}/2pn/hanh-lang`,
  },
  '68fafa1fe62230d4b4453b2c': {
    label: 'Căn hộ 2PN - Nhà vệ sinh',
    short: '2PN - Nhà vệ sinh',
    url: `/${ROUTE_MAP.interior.id}/2pn/nha-ve-sinh`,
  },

  // 3PN
  '68faffe9e62230d4b44540ff': {
    label: 'Căn hộ 3PN',
    short: '3PN',
    url: `/${ROUTE_MAP.interior.id}/3pn/tong-quan`,
  },
  '68fafc43e62230d4b4453e08': {
    label: 'Căn hộ 3PN - Phòng bếp',
    short: '3PN - Phòng bếp',
    url: `/${ROUTE_MAP.interior.id}/3pn/phong-bep`,
  },
  '68fafffae62230d4b4454114': {
    label: 'Căn hộ 3PN - Phòng khách',
    short: '3PN - Phòng khách',
    url: `/${ROUTE_MAP.interior.id}/3pn/phong-khach`,
  },
  '68fafd8be62230d4b4453f60': {
    label: 'Căn hộ 3PN - Nhà vệ sinh 1',
    short: '3PN - Nhà vệ sinh 1',
    url: `/${ROUTE_MAP.interior.id}/3pn/nha-ve-sinh-1`,
  },
  '68fafc59e62230d4b4453e29': {
    label: 'Căn hộ 3PN - Phòng ngủ 1',
    short: '3PN - Phòng ngủ 1',
    url: `/${ROUTE_MAP.interior.id}/3pn/phong-ngu-1`,
  },
  '68fafd9be62230d4b4453f75': {
    label: 'Căn hộ 3PN - Nhà vệ sinh 2',
    short: '3PN - Nhà vệ sinh 2',
    url: `/${ROUTE_MAP.interior.id}/3pn/nha-ve-sinh-2`,
  },
  '68fafdaee62230d4b4453f99': {
    label: 'Căn hộ 3PN - Phòng ngủ 3',
    short: '3PN - Phòng ngủ 3',
    url: `/${ROUTE_MAP.interior.id}/3pn/phong-ngu-3`,
  },
  '68fafc29e62230d4b4453dee': {
    label: 'Căn hộ 3PN - Ban công',
    short: '3PN - Ban công',
    url: `/${ROUTE_MAP.interior.id}/3pn/ban-cong`,
  },
  '69129061306dc464b887ed69': {
    label: 'Căn hộ 3PN - Phòng ngủ 2',
    short: '3PN - Phòng ngủ 2',
    url: `/${ROUTE_MAP.interior.id}/3pn/phong-ngu-2`,
  },
};

export const SCENES_MAP = {
  '68e768a4fa4f187e528e21c2': {
    label: 'Tổng quan The Win City',
    short: 'Tổng quan',
    url: `/${ROUTE_MAP.overview.id}`,
  },
  ...AMENITIES_MAP,
  ...APARTMENT_MAP,
};
